export default "/kiban/_next/static/images/top_purple-d38b8ebba7f62eb3f8ff9be963d739e1.png";